// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { newsListViewStyles } from "@insite/content-library/Widgets/NewsList/NewsListView";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import ArrowRight from "@sc/XDL/Icons/ArrowRight";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

newsListViewStyles.listWrapper = {
    css: css`
        gap: 22px;
        display: flex;
        flex-wrap: wrap;
    `,
};

newsListViewStyles.newsWrapper = {
    css: css`
        border-radius: 4px;
        border: 1px solid ${color("common.border")};
        width: calc(25% - 11px);
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        ${xScreen("lte", "md")} {
            width: calc(50% - 11px);
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

newsListViewStyles.dateAndAuthorWrapper = {
    css: css`
        display: flex;
        flex-direction: column-reverse;
    `,
};

newsListViewStyles.authorText = {
    size: 20,
    lineHeight: "28px",
    weight: "bold",
};

newsListViewStyles.readMoreLink = {
    icon: {
        iconProps: {
            src: ArrowRight,
            mergeCss: true,
            color: "primary",
            css: css`
                margin-left: 8px;
                opacity: 0.66;
                svg {
                    width: 14px;
                    height: 16px;
                }
            `,
        },
        position: "right",
    },
    typographyProps: {
        size: 16,
        weight: "bold",
        ellipsis: true,
        css: css`
            line-height: 18px;
        `,
    },
    css: css`
        justify-content: flex-end;
        &:hover {
            & > ${IconWrapper}, & > ${TypographyStyle} {
                color: ${color("common.ui8")};
                opacity: 1;
                transition: none;
            }
        }
    `,
};

newsListViewStyles.titleText = {
    css: css`
        margin: 0%;
        & ${TypographyStyle} {
            font-size: 16px;
            font-weight: bold;
            line-height: 18px;
            justify-content: flex-end;
        }
        &:hover {
            & ${TypographyStyle} {
                color: ${color("common.ui8")};
                opacity: 1;
                transition: none;
            }
        }
    `,
};
